import {HexMath} from '../../HexMath.js';
import {SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {coordsToKey} from "../../coords/coordsToKey";
import {checkIfHexBlockedByEnemyUnit} from "../checkIfHexBlockedByEnemyUnit";
import {findOwner} from "../findOwner";

export const checkIfAdjacentToWorkingWarehouse = (hexKey, specialBuildings, units, players, citiesCache, currentPlayer, hexes, buildingsDamage) => {
  const [q, r] = hexKey.split(',').map(Number);

  const neighbors = new HexMath().getNeighborsFlatTop(q, r);

  let isAdjacentToWorkingWarehouse = false;
  for (const [nq, nr] of neighbors) {
    const neighborKey = coordsToKey(nq, nr);

    if (specialBuildings[neighborKey] === SPECIAL_BUILDING_TOKENS.WAREHOUSE) {
      // Если не находим владельца, значит это специальное строение еще не попало в citiesCache,
      // Так как он не пересчитывается в фазе строительства до ее завершения.
      const owner = findOwner(hexKey, players, citiesCache) || currentPlayer;

      if (!checkIfHexBlockedByEnemyUnit(neighborKey, SPECIAL_BUILDING_TOKENS.WAREHOUSE, owner.id, units, hexes, specialBuildings, buildingsDamage)) {
        isAdjacentToWorkingWarehouse = true;
        break;
      }
    }
  }

  return isAdjacentToWorkingWarehouse;
};
